import React from 'react';
import { useParams } from 'react-router-dom';
import { ProteinDesignInput } from '../components/ProteinDesignInput';

export default function MoleculeViewerPage() {
  const { id } = useParams<{ id: string }>();
  
  if (!id) {
    return (
      <div className="flex items-center justify-center h-screen">
        <p className="text-gray-500">No molecule ID provided</p>
      </div>
    );
  }

  return <ProteinDesignInput moleculeId={id} />;
}